// `@hqo/date-time/core` is a package `exports` subpath. tsc, the webpack build, and jest (via the
// moduleNameMapper in package.json) all resolve it, but eslint-import-resolver-node predates the
// `exports` field and this repo ships no TypeScript resolver, so the import lint can't follow it.
// eslint-disable-next-line import/no-unresolved
import { normalizeLocale, resolvePresentationLocale } from '@hqo/date-time/core';
import { MILLISECONDS_PER_SECOND } from 'shared/consts/time';

export enum FORMAT {
  TIME = 'time',
  MONTH_DAY = 'month_day',
  MONTH_DAY_TIME = 'month_day_time',
}

export const formatEpochTo = (epochTimestamp: number, locale: string, format: FORMAT): string => {
  // Resolve the presentation locale so a bare `en` on a British device picks up `en-GB` (24-hour
  // clock, day-month order) rather than defaulting to US conventions (VIS-1951). The resolver only
  // borrows a region from the device when it matches the SAME language, so it never cross-pollinates.
  //
  // `normalizeLocale` FIRST: the building locale can arrive as a POSIX `LANG` (`en_GB.UTF-8`,
  // `de_DE@euro`), and `resolvePresentationLocale` expects an already-clean UI tag — it does not strip
  // the codeset/modifier itself, so handing it the raw value drops the region and presents `en_GB.UTF-8`
  // as US English, the exact bug this fixes for bare `en`. An empty/absent locale falls through to the
  // device (tier 3).
  const presentationLocale = resolvePresentationLocale(locale ? normalizeLocale(locale) : undefined);

  const date = new Date(epochTimestamp * MILLISECONDS_PER_SECOND);
  const monthDay = date.toLocaleString(presentationLocale, { month: 'long', day: 'numeric' });
  const time = date
    .toLocaleString(presentationLocale, { hour: 'numeric', minute: '2-digit' })
    .toLowerCase()
    .replace(/\s/g, '');

  switch (format) {
  case FORMAT.TIME:
    return time;
  case FORMAT.MONTH_DAY:
    return monthDay;
  case FORMAT.MONTH_DAY_TIME:
    return `${monthDay}, ${time}`;
  default:
    return format;
  }
};
